var resources = require('items-view-strings');
    var strings = resources['_5Plj/7XI8cNhSL9VDNaWdQ'];
export { strings };
export default strings;
